<div class="selected-product-item">
  @if (product) {
    <button
      class="remove-btn"
      type="button"
      (click)="onRemove()"
      aria-label="Remove product"
    >
      <mat-icon>close</mat-icon>
    </button>
    <img
      [src]="product.imageThumbUrl"
      alt="{{ product.productTitle }}"
      class="product-image"
    />
  } @else {
    <div class="placeholder">
      <mat-icon>add_shopping_cart</mat-icon>
    </div>
  }
</div>

<h3 class="product-title">{{ product?.productTitle }}</h3>
